// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2P1CB","list":"styles_list__nVj0m"};